import React, { useState, useRef, useEffect } from 'react';
import { MdErrorOutline, MdOutlineCloudDone } from "react-icons/md";
import { RiUploadCloud2Line } from "react-icons/ri";
import { FaRegFileAlt } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import '../../components/ThreeTab/ThreeTab/MyBusiness.css';
import { getUserDetails, updateUserDetails } from '../../API/Api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SidebarTab from '.././SidebarTab/SidebarTab';
import { getAuthToken, setAuthData } from '../../utils/auth';

const MyBusiness = () => {
	const [activeTab, setActiveTab] = useState('other-details');
	const [cancelChequeFile, setCancelChequeFile] = useState(null);
	const [userData, setUserData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const cancelChequeFileInputRef = useRef(null);
	const [isEditing, setIsEditing] = useState(false);
	const [formData, setFormData] = useState({
		communication_channels: "Email",

	});
	const [initialFormData, setInitialFormData] = useState({});

	useEffect(() => {
		const fetchUserDetails = async () => {
			try {
				const response = await getUserDetails();
				setUserData(response.user);
				const initialData = {
					first_name: response.user.first_name,
					last_name: response.user.last_name,
					company_name: response.user.company_name,
					type: response.user.type || "",
					display_name: response.user.display_name,
					email: response.user.email,
					ph_number: response.user.ph_number,
					customer_unique_id: response.user.customer_unique_id,
					communication_channels: response.user.communication_channels || "Email",
					msme: response.user.msme,
					msme_number: response.user.msme_number,
					pan_card: response.user.pan_card,
					gstTreatment: response.user.gstTreatment,
					GSTIN: response.user.GSTIN,
					bank_name: response.user.bank_name,
					account_number: response.user.account_number,
					account_holder_name: response.user.account_holder_name,
					ifsc_code: response.user.ifsc_code,
					cancelled_cheque: response.user.cancelled_cheque,
					contact_person_phone_number: response.user.contact_person_phone_number
				};

				console.log("GSTTTTTTTTT:-", response)
				setFormData(initialData);
				setInitialFormData(initialData);
				setLoading(false);
				setAuthData({
					token: getAuthToken(),
					user: {
						...response.user,
						user_type: response.user.user_type,
						verified: response.user.verified
					}
				});
			} catch (err) {
				setError(err.message || 'Failed to fetch user details');
				setLoading(false);
			}
		};

		fetchUserDetails();
	}, []);

	const hasFormChanges = () => {
		return JSON.stringify(formData) !== JSON.stringify(initialFormData);
	};

	const handleTabClick = (tab) => {
		setActiveTab(tab);
	};

	const handleFileChange = (e, fileType) => {
		if (fileType === "cancelledCheque") {
			const file = e.target.files[0];
			setCancelChequeFile(file); // Store the file object
			setFormData({
				...formData,
				cancelled_cheque: file.name // Update the display name
			});
		}
	};
	const handleFileDelete = (fileType) => {
		if (fileType === "cancelledCheque") {
			setCancelChequeFile(null);
			setFormData({
				...formData,
				cancelled_cheque: ''
			});
		}
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value
		});
	};

	const handleRadioChange = (name, value) => {
		setFormData({
			...formData,
			[name]: value
		});
	};

	const handleEditClick = () => {
		setIsEditing(true);
	};

	const handleSave = async () => {
		try {
			setLoading(true);

			const formDataPayload = new FormData();

			for (const key in formData) {
				if (key !== 'cancelled_cheque') {
					formDataPayload.append(key, formData[key]);
				}
			}

			if (cancelChequeFile) {
				console.log("cancelChequeFile:----", cancelChequeFile)
				formDataPayload.append('cancelled_cheque', cancelChequeFile);
			}
			const response = await updateUserDetails(formDataPayload, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'Authorization': `Bearer ${getAuthToken()}`
				}
			});

			console.log("Update successful:", response);
			const updatedUser = {
				...userData,
				...response.user
			};

			setUserData(updatedUser);
			setFormData(updatedUser);
			setInitialFormData(updatedUser);
			setCancelChequeFile(null);

			setAuthData({
				token: getAuthToken(),
				user: {
					...updatedUser,
					user_type: userData.user_type,
					verified: userData.verified
				}
			});

			setIsEditing(false);
			toast.success("Details updated successfully");
		} catch (err) {
			console.error("Update failed:", err);
			setError(err.message || 'Failed to update details');
			toast.error(err.response?.data?.message || "Failed to update details. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	if (!userData) {
	}

	return (<div className="verification-container">
		<SidebarTab />

		<div className="my-business-container">
			<div className="account-details-header">
				<h2 className="form-title">Account Details</h2>
				<div className="header-buttons">
					{!isEditing ? (
						<button className="edit-button-business" onClick={handleEditClick}>
							Edit Details
						</button>
					) : (
						<>
							<button className="edit-button-business" onClick={() => setIsEditing(false)}>
								Cancel
							</button>
							<button
								className="save-button-business"
								onClick={handleSave}
								disabled={!isEditing || !hasFormChanges()}
							>
								Save Details
							</button>
						</>
					)}
				</div>
			</div>
			<div className="form-section">
				<div className="account-type">
					<label className="label">
						Account Type
						<MdErrorOutline className="error-icon" />
					</label>
					<div className="form-group">
						<label htmlFor="companyTypes" className="companyTypes"></label>
						<select
							id="companyType"
							name="type"
							value={formData.type || ''}
							onChange={handleInputChange}
							className="dropdown-business business-type"
							required
							disabled={!isEditing}
						>
							<option value="" disabled>Select Company Type</option>
							<option value="Sole Proprietorship">Sole Proprietorship</option>
							<option value="One Person Company">One Person Company</option>
							<option value="Partnership Firm">Partnership Firm</option>
							<option value="LLP">Limited Liability Partnership (LLP)</option>
							<option value="Section 8 Company">Section 8 Company</option>
							<option value="Public Company">Public Company</option>
							<option value="Private Company">Private Company</option>
						</select>

					</div>
				</div>
				<div className="name-fields">
					<label className="label">
						Primary Contact
						<MdErrorOutline className="error-icon" />
					</label>
					<div className="input-group">
						<select className="input-field select-field" disabled={!isEditing}>
							<option value="" disabled>Salutation</option>

							<option value="mr">Mr.</option>
							<option value="ms">Ms.</option>
							<option value="mrs">Mrs.</option>
						</select>
						<input
							type="text"
							name="first_name"
							placeholder="First name"
							className="input-field"
							value={formData.first_name || ''}
							onChange={handleInputChange}
							disabled={!isEditing}
						/>
						<input
							type="text"
							name="last_name"
							placeholder="Last name"
							className="input-field"
							value={formData.last_name || ''}
							onChange={handleInputChange}
							disabled={!isEditing}
						/>
					</div>
				</div>
				<div className="company-name">
					<label className="label" >Company Name</label>
					<input
						type="text"
						name="company_name"
						className="input-field"
						value={formData.company_name || ''}
						onChange={handleInputChange}
						disabled
					/>
				</div>

				<div className="display-name">
					<label className="label">
						Display Name
						<MdErrorOutline className="error-icon" />
					</label>
					<input
						type="text"
						name="display_name"
						className="input-field"
						value={formData.display_name || ''}
						onChange={handleInputChange}
						disabled={!isEditing}
					/>
				</div>
				<div className="email-container">
					<label className="label">
						Email Address
						<MdErrorOutline className="error-icon" />
					</label>
					<input
						type="email"
						name="email"
						className="input-field email-input"
						value={formData.email || ''}
						onChange={handleInputChange}
						disabled
					/>
					<span className="email-icon">
						{/* <MdEmail /> */}
					</span>
				</div>
				<div className="customer-number">
					<label className="label">
						Customer Number
						<MdErrorOutline className="error-icon" />
					</label>
					<input
						type="text"
						className="input-field readonly-input"
						value={formData.customer_unique_id || ''}
						disabled
					/>
				</div>

				<div className="contact-fields">
					<label className="label" style={{ display: 'flex', alignItems: 'center' }}>
						Phone
						<MdErrorOutline className="error-icon" />
					</label>
					<div className="input-container-business">
						{/* <MdOutlineCall className="phone-icon-business" /> */}
						<input
							type="tel"
							name="ph_number"
							placeholder="Primary Phone number"
							className="input-field-business"
							value={formData.ph_number || ''}
							onChange={handleInputChange}
							disabled
						/>
					</div>
					<div className="input-container-business">
						{/* <CiMobile1 className="mobile-icon-business" /> */}
						<input
							type="tel"
							name="mobile_number"
							placeholder="Secondary Phone number"
							className="input-field-business"
							value={formData.ph_number || ''}
							onChange={handleInputChange}
							disabled={!isEditing}
						/>
					</div>
				</div>

				<div className="communication-channels">
					<label className="label">
						Communication Channels
						<MdErrorOutline className="error-icon" />
					</label>
					<div className="radio-groups">
						<label className="radio-label">
							<input
								type="radio"
								name="communication_channels"
								checked={formData.communication_channels === "email"}
								onChange={() => handleRadioChange("communication_channels", "email")}
								disabled={!isEditing}
							/> Email
						</label>
						<label className="radio-label">
							<input
								type="radio"
								name="communication_channels"
								checked={formData.communication_channels === "sms"}
								onChange={() => handleRadioChange("communication_channels", "sms")}
								disabled
							/> SMS
						</label>
					</div>
				</div>
			</div>
			<div className="business-details-section">
				<h3 className="business-details-title">Business Details</h3>
				<div className="msme" style={{ marginBottom: '20px' }}>
					<label className="label" style={{ marginBottom: '0px' }}>
						MSME*
						<div className="radio-groups">
							<label className="radio-label">
								<input
									type="radio"
									name="msme"
									checked={formData.msme === "yes"}
									onChange={() => handleRadioChange("msme", "yes")}
									disabled={!isEditing}
								/> Yes
							</label>
							<label className="radio-label">
								<input
									type="radio"
									name="msme"
									checked={formData.msme === "no"}
									onChange={() => handleRadioChange("msme", "no")}
									disabled={!isEditing}
								/> No
							</label>
						</div>
					</label>

					{formData.msme === "yes" && (
						<div style={{ marginLeft: '23%', marginTop: '5px' }}>
							<input
								type="text"
								name="msme_number"
								className="input-field msme-input"
								placeholder="UDYAM-XX-00-0000000"
								value={formData.msme_number || ''}
								onChange={(e) => {
									handleInputChange(e);
									toast.dismiss();

									const value = e.target.value;
									if (value.length >= 19 && !/^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/.test(value)) {
										toast.error('Invalid UDYAM format. Required format: UDYAM-XX-00-0000000');
									}
								}}
								onBlur={(e) => {
									const value = e.target.value;
									if (value && value.length >= 19 && !/^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/.test(value)) {
										toast.dismiss();
										toast.error('Invalid UDYAM format. Required format: UDYAM-XX-00-0000000');
									}
								}}
								maxLength={19}
								disabled={!isEditing}
							/>
						</div>
					)}
				</div>
				<div className="pan">
					<label className="label">
						PAN of company*
						<input
							type="text"
							name="pan_card"
							className="input-field msme-input"
							value={formData.pan_card || ''}
							onChange={handleInputChange}
							disabled
						/>
					</label>
				</div>
				<div className="tax">
					<label className="label">
						GST Treatment*
						<div className="radio-groups">
							<label className="radio-label">
								<input
									type="radio"
									name="gstTreatment"
									checked={formData.gstTreatment === "Regular"}
									onChange={() => handleRadioChange("gstTreatment", "Regular")}
									disabled={!isEditing}
								/> Regular
							</label>
							<label className="radio-label">
								<input
									type="radio"
									name="gstTreatment"
									checked={formData.gstTreatment === "Composition"}
									onChange={() => handleRadioChange("gstTreatment", "Composition")}
									disabled={!isEditing}
								/> Composition
							</label>
							<label className="radio-label">
								<input
									type="radio"
									name="gstTreatment"
									checked={formData.gstTreatment === "Sez"}
									onChange={() => handleRadioChange("gstTreatment", "Sez")}
									disabled={!isEditing}
								/> SEZ
							</label>
							<label className="radio-label">
								<input
									type="radio"
									name="gstTreatment"
									checked={formData.gstTreatment === "Exempted"}
									onChange={() => handleRadioChange("gstTreatment", "Exempted")}
									disabled={!isEditing}
								/> Exempted
							</label>
							<label className="radio-label">
								<input
									type="radio"
									name="gstTreatment"
									checked={formData.gstTreatment === "Nongst"}
									onChange={() => handleRadioChange("gstTreatment", "Nongst")}
									disabled={!isEditing}
								/> Non-GST
							</label>
							<label className="radio-label">
								<input
									type="radio"
									name="gstTreatment"
									checked={formData.gstTreatment === "Unregistered"}
									onChange={() => handleRadioChange("gstTreatment", "Unregistered")}
									disabled={!isEditing}
								/> Unregistered
							</label>
							<label className="radio-label">
								<input
									type="radio"
									name="gstTreatment"
									checked={formData.gstTreatment === "Overseas"}
									onChange={() => handleRadioChange("gstTreatment", "Overseas")}
									disabled={!isEditing}
								/> Overseas
							</label>
						</div>
					</label>
				</div>


				<div className="gst-number">
					<label className="label">
						GST Number
						<MdErrorOutline className="error-icon" />
					</label>
					<input
						type="text"
						name="GSTIN"
						className="input-field readonly-input"
						value={formData.GSTIN || ''}
						onChange={handleInputChange}
						disabled
						readOnly
					/>
				</div>

				<div className="other-details-section">
					<div className="other-contact-header">
						<h3
							className={`other-details-title ${activeTab === 'other-details' ? 'active' : ''}`}
							onClick={() => handleTabClick('other-details')}
						>
							Other Details
						</h3>
						<h3
							className={`other-details-title ${activeTab === 'contact-persons' ? 'active' : ''}`}
							onClick={() => handleTabClick('contact-persons')}
						>
							Contact Persons
						</h3>
					</div>

					{activeTab === 'other-details' && (
						<div className="form-group">
							<div className="bank-name">
								<label className="label">
									Bank Name
									<MdErrorOutline className="error-icon" />
								</label>
								<input
									type="text"
									name="bank_name"
									className="input-field"
									value={formData.bank_name || ''}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
							</div>
							<div className="account-name">
								<label className="label">
									Account Number
									<MdErrorOutline className="error-icon" />
								</label>
								<input
									type="text"
									name="account_number"
									className="input-field"
									value={formData.account_number || ''}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
							</div>
							<div className="account-holder-name">
								<label className="label">
									Account Holder Name
									<MdErrorOutline className="error-icon" />
								</label>
								<input
									type="text"
									name="account_holder_name"
									className="input-field"
									value={formData.account_holder_name || ''}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
							</div>
							<div className="ifsc-name">
								<label className="label">
									IFSC Code
									<MdErrorOutline className="error-icon" />
								</label>
								<input
									type="text"
									name="ifsc_code"
									className="input-field"
									value={formData.ifsc_code || ''}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
							</div>
							<div className="cheque-name">
								<label className="label">
									Cancelled Cheque
									<MdErrorOutline className="error-icon" />
								</label>
								<div className="input-wrapper">
									<input
										type="text"
										className="input-field"
										value={formData.cancelled_cheque || ''}
										onChange={handleInputChange}
										disabled
									/>
									{formData.cancelled_cheque ? (
										<div className="fileInfo">
											<FaRegFileAlt />
											<span>Cheque uploaded</span>
											<MdOutlineCloudDone className="uploadSuccessIcon" />
											{isEditing && (
												<RiDeleteBin5Line
													className="delete-icon"
													onClick={() => handleFileDelete("cancelledCheque")}
												/>
											)}
										</div>
									) : (
										<>
											<button
												className="upload-button"
												onClick={() => cancelChequeFileInputRef.current.click()}
												disabled={!isEditing}
											>
												<RiUploadCloud2Line /> Upload
											</button>
											<input
												type="file"
												ref={cancelChequeFileInputRef}
												style={{ display: 'none' }}
												onChange={(e) => handleFileChange(e, "cancelledCheque")}
											/>
										</>
									)}
								</div>
							</div>
						</div>
					)}

					{activeTab === 'contact-persons' && (
						<div className="contact-persons-form">
							<div className="company-name">
								<label className="label">
									Name
									<MdErrorOutline className="error-icon" />
								</label>
								<input
									type="text"
									name="contact_person_name"
									className="input-field"
									value={formData.contact_person_name || ''}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
							</div>

							<div className="company-name">
								<label className="label">
									Email
									<MdErrorOutline className="error-icon" />
								</label>
								<input
									type="email"
									name="contact_person_email"
									className="input-field"
									value={formData.contact_person_email || ''}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
							</div>

							<div className="company-name">
								<label className="label">
									Phone Number
									<MdErrorOutline className="error-icon" />
								</label>
								<input
									type="text"
									name="contact_person_phone_number"
									className="input-field"
									value={formData.contact_person_phone_number || ''}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
							</div>
						</div>

					)}
					<button className="saveBtnBsn" onClick={handleSave}
						disabled={!isEditing || !hasFormChanges()}
					>
						SAVE DETAILS
					</button>
				</div>
			</div>
		</div>
	</div>
	);
};

export default MyBusiness;